<template>
  <div>
    <QueryFrame :disablePage="true">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleClick">单据补打</lk-button>
            <lk-button class="mr" type="primary" @click="handleClickRefund">退款</lk-button>
            <lk-button class="mr" type="primary" @click="changePassword">修改密码</lk-button>
          </div>
        </div>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="showModal"
      title="单据补打"
      :closable='false'
      @on-ok="confirm"
      @on-cancel="cancel">
      <div>
        销售单号:
        <lk-input v-model="orderCode"></lk-input>
      </div>
    </lk-modal>
    <lk-modal
      v-model="ModalRefund"
      title="退款"
      :closable='false'
      @on-ok="confirmRe"
      @on-cancel="cancelRe">
      <div>
        销售单号:
        <lk-input v-model="orderCode"></lk-input>
      </div>
    </lk-modal>
    <lanZhouPrintModel v-show="false" ref='lanZhouPrintModel'></lanZhouPrintModel>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insuranceLanzhou';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import lanZhouPrintModel from './lanZhouPrintModel.vue';

export default {
  name: 'PrintInvoice',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    lanZhouPrintModel
  },
  computed: {},
  data() {
    return {
      showModal: false,
      orderCode: null,
      ModalRefund: false,
      orderCodeRe: null,
    };
  },
  methods: {
    handleClick() {
      this.showModal = true;
    },
    cancel() {
      this.showModal = false;
    },
    changePassword() {
      insurance.insuranceUser({
        type: 3, //3医保卡
        operate: 2 //1读卡，2修改密码
      }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('修改成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      })
    },
    confirm() {
      const params = { orderCode: this.orderCode };
      insurance.print(params).then((res) => {
        if (res.data.status === 200) {
          this.$refs.lanZhouPrintModel.tableData = res.data.data;
          this.$nextTick(() => {
            this.$refs.lanZhouPrintModel.handlePrint();
          })
          this.showModal = false;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      })
    },
    handleClickRefund() {
      this.ModalRefund = true;
    },
    cancelRe() {
      this.ModalRefund = false;
    },
    confirmRe() {
      insurance.refund(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('退款成功');
          this.ModalRefund = false;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 8px;
    >* {
      margin-right: 8px
    }
  }
</style>
